module.exports = __webpack_public_path__ + "static/media/option-2.d4a71dfc.ogg";